export default __webpack_public_path__ + "static/media/icon-calendar.f1af4b7a.svg";